// Shared with the employee registry: center first, then five yellow flashes.
const highlightClass = 'employee-row-return-highlight';

function centerRow(target, container, bounds) {
    if (!target) return;
    if (!container && !bounds) {
        target.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
    }
    const scroll = container || document.scrollingElement;
    const rect = target.getBoundingClientRect();
    const area = bounds || {top: container.getBoundingClientRect().top, bottom: container.getBoundingClientRect().top + container.clientHeight};
    const top = Math.max(0, scroll.scrollTop + rect.top - area.top - (area.bottom - area.top - rect.height) / 2);
    if (typeof scroll.scrollTo === 'function') scroll.scrollTo({top, behavior: 'smooth'});
    else scroll.scrollTop = top;
}

function blinkRow(target) {
    target.classList.remove(highlightClass);
    void target.offsetWidth;
    target.classList.add(highlightClass);
    const cleanup = () => target.classList.remove(highlightClass);
    const timer = setTimeout(cleanup, 1800);
    return () => { clearTimeout(timer); cleanup(); };
}

function returnToRow(resolveTarget, options = {}) {
    if (!resolveTarget()) return () => {};
    let frame, timer, stopBlink, cancelled = false;
    // Wait for browser scroll anchoring after a tall history/editor collapses.
    frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(() => {
            if (cancelled) return;
            const target = resolveTarget();
            if (!target || target.isConnected === false) return;
            const container = options.container ? options.container(target) : null;
            centerRow(target, container, options.bounds && options.bounds(target, container));
            let lastTop, stable = 0, attempts = 0, corrected = false;
            const afterScroll = () => {
                const current = resolveTarget();
                if (cancelled || !current || current.isConnected === false) return;
                const top = current.getBoundingClientRect().top;
                stable = lastTop != null && Math.abs(lastTop - top) < 1 ? stable + 1 : 0;
                lastTop = top;
                if (stable >= 2 && !corrected && options.bounds) {
                    // Sticky headers may appear during the smooth scroll itself.
                    corrected = true; stable = 0; lastTop = null;
                    centerRow(current, container, options.bounds(current, container));
                    timer = setTimeout(afterScroll, 50);
                } else if (stable >= 2 || ++attempts >= 30) stopBlink = blinkRow(current);
                else timer = setTimeout(afterScroll, 50);
            };
            timer = setTimeout(afterScroll, 450);
        });
    });
    return () => { cancelled = true; cancelAnimationFrame(frame); clearTimeout(timer); if (stopBlink) stopBlink(); };
}

module.exports = {centerRow, blinkRow, returnToRow};
